import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/location-selector-hero@2x.png")